/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_ALL_APPLICATIONS, SET_NO_APPLICATION, SET_SELECTED_APPLICATION, REMOVE_APPLICATION } from "./types";

const initialState = {
  applications: [],
  noApplication: true,
  selectedApplication: {},
};

export const applicationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_APPLICATIONS:
      return {
        ...state,
        applications: action.applications,
        noApplication: action.noApplication,
        selectedApplication: action.selectedApplication
      };
    case SET_SELECTED_APPLICATION:
      return {
        ...state,
        selectedApplication: action.selectedApplication,
      };
    case SET_NO_APPLICATION:
      return {
        ...state,
        noApplications: action.noApplication,
      };
    case REMOVE_APPLICATION:
      const appList = state.applications.filter((application: any) => application.id !== action.applicationId)
      return {
        ...state,
        applications: appList,
      }
    default:
      return state;
  }
};
